export default __webpack_public_path__ + "static/media/2021_Ke_et_al_2021_NewPhytologist.45df0861.pdf";